import { observable } from "mobx";

export class Status {
    @observable code: string;
    @observable message: string;
    @observable triggeredByUserId: string;
    @observable triggeredAtDate: any;

    constructor() {
        this.code = "";
        this.message = "";
        this.triggeredByUserId = "";
        this.triggeredAtDate = null;
    }
}